export const parsePriceList = (raw, lang = 'fr') => {
  let list;
  try {
    list = JSON.parse(raw || '[]');
  } catch (_) {
    return [];
  }
  if (!Array.isArray(list)) {
    return [];
  }
  return list
    .map(price => ({
      label: price[`text_${lang}`] || price.text || '',
      price: price.price,
    }))
    .filter(price => price.label && (price.price || price.price === 0));
};

export const formatAddress = (site) => {
  const cityLine = [site.zipcode, site.city].filter(Boolean).join(' ');
  const full = [site.address, cityLine].filter(Boolean).join(', ');
  return full || null;
};

export const mapsUrl = (site) =>
  (site.latitude && site.longitude)
    ? `https://www.google.com/maps?q=${site.latitude},${site.longitude}`
    : null;

export const formatDuration = (minutes) => {
  if (!minutes) {
    return null;
  }
  const hours = Math.trunc(minutes / 60);
  const mins = Math.round(minutes % 60);
  if (hours === 0) {
    return `${mins}min`;
  }
  return mins > 0 ? `${hours}h${String(mins).padStart(2, '0')}` : `${hours}h`;
};
